<section class="content">
    <div class="container-fluid ml-lg-3 ml-2">
        <div class="row">
            <div class="row mt-3">
                <div class="col-lg-4 col-md-4 col-12 mb-3">
                    <div class="form-floating">
                        <select class="form-select" id="floatingSelect"
                                aria-label="Floating label select example"
                                (change)="selectPostName($event)">
                            <option selected>Select Post Name</option>
                            <option value="All">All</option>
                            <option *ngFor="let name of this.postName">{{ name }}</option>
                        </select>
                        <label for="floatingSelect">Select Post Name</label>
                    </div>
                </div>
                <!--<div class="col-lg-4 col-md-4 col-12 mb-3">
                    <div class="form-floating">
                        <select class="form-select"
                                aria-label="Floating label select example" (change)="productFilter($event, 'location')">
                            <option selected disabled>Select User Location</option>
                            <option value="All">All</option>
                            <option *ngFor="let location of this.productLocation">{{ location }}</option>
                        </select>
                        <label for="floatingSelect">Location</label>
                    </div>
                </div>-->
                <div class="col-lg-4 col-md-4 col-12 mb-3">
                    <div class="form-floating">
                        <input type="search" class="form-control" placeholder="search"
                               [(ngModel)]="searchText">
                        <label class="text-gray">Search</label>
                    </div>
                </div>
            </div>


            <div class="content-card mt-4 mb-4">
                <!--<mat-card class="col-lg-3 mb-3 mt-3 example-card" *ngFor="let post of this.postDetailsList">-->
                <mat-card class="items" *ngFor="let post of this.postDetails | filter: searchText;">
                    <div class="d-flex flex-column h-100">
                        <mat-card-header>
                            <div mat-card-avatar class="example-header-image">
                                <h5 class="icon-circle"><h5
                                        class="fw-bolder text-uppercase text-center text-white mt-2">{{post.postName.charAt(0).toUpperCase()}}</h5>
                                </h5>
                            </div>
                            <mat-card-title class="fw-bold"><h6>{{post.postName}}</h6></mat-card-title>
                            <mat-card-subtitle class="text-black">{{post.friendlyName}}</mat-card-subtitle>
                        </mat-card-header>
                        <img mat-card-image class="object-fit-contain"
                             *ngIf="post.postImageList?.length > 0 && post.postImageList[0].imageId"
                             [src]="endPoint + '/api/image-details/get/' + post.postImageList[0].imageId"
                             alt="image" loading="lazy">
                        <mat-card-content class="flex-grow-1">
                            <h6 class="mb-2">{{post.userName}}</h6>
                            <p class="mb-2 text-gray">{{post.phoneNumber}}</p>
                        </mat-card-content>
                        <mat-card-actions class="text-end">
                            <button class="btn-inactive mr-md-4 mt-1" (click)="viewPostDetail(post.postId)">View
                            </button>
                            <span [ngClass]="{'badge-active': post.approvalStatus === 'Approved', 'badge-inactive': post.approvalStatus !== 'Approved'}"
                                  class="text-white">{{post.approvalStatus}}</span>
                        </mat-card-actions>
                    </div>
                </mat-card>
            </div>
        </div>
    </div>
</section>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" type="jelly-box">
    <div class="loader">
        <div class="inner one"></div>
        <div class="inner two"></div>
        <div class="inner three"></div>
    </div>
</ngx-spinner>
